import { Component, Input } from '@angular/core';

@Component({
    selector: 'loading-container',
    template: `
    <div [ngSwitch]="loading">
	<div *ngSwitchCase="false">
	    <ng-content></ng-content>
        </div>
	<div *ngSwitchCase="true" class="spinner">
	<loaders-css [loader]="'pacman'" [loaderClass]="'my-spinner'"></loaders-css>
         
    </div>`
})
export class LoadingContainer {
    @Input() loading: boolean;
    constructor() { }
}

export class LoadingPage {
    public loading: boolean;
    constructor(val: boolean) {
        this.loading = val;
    }
    standby() {
        this.loading = true;
    }
    ready() {
        this.loading = false;
    }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/shared/LoadingContainer.ts